import styled from "styled-components";

export const AboutHeader = styled.h2`
  font-size: 3rem;
  padding: 2% 0% 2% 0%;
  font-family: Montserrat;
`;
export const TopText = styled.p`
  font-size: 1.6rem;
  padding: 0% 0% 2% 2%;
  width: 85%;
  margin: 0 auto;
`;
export const MiddleContentImages = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
export const Images = styled.img`
  width: 45%;
  height: 350px;
  border: 2px solid #212121;
  border-radius: 5px;
`;
export const MiddleContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;
export const ImfoSections = styled.div`
  display: flex;
  padding: 1% 0% 1% 2%;
`;
export const AboutText = styled.p`
  margin: 0 auto;
  padding: 2% 0% 0% 0%;
  width: 45vw;
  font-size: 1.8rem;
`;
export const AboutContainer = styled.div`
  width: 95vw;
  margin: 0 auto;
`;
